require('../../../../ui/dropdown/dropdownMediator');
require('./lazyLoadDropdownController');
require('./lazyLoadDropdown.tpl.html');

const LazyLoadDropdownComponent = {
    templateUrl: '/formViewer/component/dropdown/lazyLoadDropdown/lazyLoadDropdown.tpl.html',
    controller: 'umLazyLoadDropdownController',
    transclude: {
        'footerOption': '?footer',
        'feedbackMessage': '?feedback'
    },
    bindings: {
        className: '@',
        required: '<',
        optionList: '<',
        optionListCount: '<',
        placeholder: '<',
        selectedValue: '<',
        selectedName: '<',
        onChange: '&',

        onOpen: '&',
        onSearch: '&',
        isLoading: '<',
        isDisabled: '<',
        hasBusinessCard: '<',
        hasOrganizationCard: '<',
        isValid: '<',
        feedbackOverride: '<',
        maximumOptionsLimit: '<',
        componentClassName: '@',
        tooltipMessage: '<'
    }
};

angular.module('umFormViewer')
    .component('umLazyLoadDropdown', LazyLoadDropdownComponent);
